import { AttributesMixin, define, Model } from "@type-r/models";
import { getAuthorizationBearer, getPlatformCode } from "./endpoint";

export interface ImportJobAssetsDelete extends AttributesMixin<typeof ImportJobAssetsDelete> { }

@define
export class ImportJobAssetsDelete extends Model {
    async do(id: Number, assetTypeId?: Number): Promise<Response> {
        const url = `api/v1/ingest/jobs/${id}/assets/delete-all?assetTypeId=${assetTypeId}`;

        const response = await fetch(url, {
            method: 'DELETE',
            headers: new Headers({
                "Authorization": getAuthorizationBearer(),
                'Content-Type': 'application/json',
                'X-Platform-Code': getPlatformCode()
            })
        });
        if (response.status < 200 || response.status >= 300) {
            let error = response.statusText || `HTTP Error ${response.status}`;
            await response.json()
                .then(e => error = e.error);
            throw new Error(error);
        }
        return await response.json();
    }
}